import { Injectable } from '@angular/core';
import { SoilQualityType } from '@services/cleanfill-api/cleanfill-api.generated';

@Injectable({
  providedIn: 'root'
})
export class SoilQualityTypeService {
  constructor() { }

  getLabel(soilQualityType: SoilQualityType): string {
    switch (soilQualityType) {
      case SoilQualityType.AllSoilTypes:
        return 'All soil Types';
      case SoilQualityType.NonHazardousSoil:
        return 'Non-Hazardous soil';
      case SoilQualityType.OReg153Table1:
        return 'O.Reg 153 Table 1';
      case SoilQualityType.OReg153Table2:
        return 'O.Reg 153 Table 2';
      case SoilQualityType.OReg153Table3:
        return 'O.Reg 153 Table 3';
      case SoilQualityType.OReg153Table4:
        return 'O.Reg 153 Table 4';
      case SoilQualityType.OReg153Table5:
        return 'O.Reg 153 Table 5';
      case SoilQualityType.OReg153Table6:
        return 'O.Reg 153 Table 6';
      case SoilQualityType.OReg153Table7:
        return 'O.Reg 153 Table 7';
      case SoilQualityType.OReg153Table8:
        return 'O.Reg 153 Table 8';
      case SoilQualityType.OReg153Table9:
        return 'O.Reg 153 Table 9';
      case SoilQualityType.OReg406Table11:
        return 'O.Reg 406 Table 1.1';
      case SoilQualityType.OReg406Table21:
        return 'O.Reg 406 Table 2.1';
      case SoilQualityType.OReg406Table31:
        return 'O.Reg 406 Table 3.1';
      case SoilQualityType.OReg406Table41:
        return 'O.Reg 406 Table 4.1';
      case SoilQualityType.OReg406Table51:
        return 'O.Reg 406 Table 5.1';
      case SoilQualityType.OReg406Table61:
        return 'O.Reg 406 Table 6.1';
      case SoilQualityType.OReg406Table71:
        return 'O.Reg 406 Table 7.1';
      case SoilQualityType.OReg406Table81:
        return 'O.Reg 406 Table 8.1';
      case SoilQualityType.OReg406Table91:
        return 'O.Reg 406 Table 9.1';
      default:
        return '';
    }
  }
}
